/**
 * answerPaper接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const answerPaper = {
  // 问卷开始
  getQuestionnaireLoginInfo (params) {
    return axios.get('/api/answerPaper/GetQuestionnaireLoginInfo', { params })
  },
  getJoinMeetingList (params) {
    return axios.get('/api/answerPaper/GetJoinMeetingList', { params })
  },
  getMeetingQuestionnaireInfo (params) {
    return axios.get('/api/answerPaper/GetMeetingQuestionnaireInfo', { params })
  },
  getAnswerPaperState (params) {
    return axios.get('/api/answerPaper/GetAnswerPaperState', { params })
  },
  // 答卷
  getCurrentUserAnswerPaper (params) {
    return axios.get('/api/answerPaper/GetCurrentUserAnswerPaper', { params })
  },
  getAnswerPaperByUserId (params) {
    return axios.get('/api/answerPaper/GetAnswerPaperByUserId', { params })
  },
  saveAnswerPaper (params) {
    return axios.post('/api/answerPaper/SaveAnswerPaper', params)
  },
  // 阅卷
  markingAnswerPaper (params) {
    return axios.post('/api/answerPaper/MarkingAnswerPaper', params)
  },
  markingAnswerPaperByManualMerge (params) {
    return axios.post('/api/answerPaper/MarkingAnswerPaperByManualMerge', params)
  }
}

export default answerPaper
